import { render, staticRenderFns } from "./modalAddSiipSetup.vue?vue&type=template&id=20ca0fba&"
import script from "./modalAddSiipSetup.vue?vue&type=script&lang=js&"
export * from "./modalAddSiipSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports